{
  "versi": 1,
  "mapel": "bahasa-indonesia",
  "keterangan": "Soal pengembangan: teks kembaran bank soal (gaya dan tingkat kesulitan mirip, cerita/topik berbeda).",
  "bacaan": [
    {
      "id": "pc-sarapan",
      "jenis": "Teks Informasi",
      "judul": "Manfaat Sarapan Pagi bagi Anak Sekolah",
      "teks": "Sarapan adalah kegiatan makan pada pagi hari sebelum memulai aktivitas. Setelah tidur sepanjang malam, perut kita kosong selama berjam-jam. Karena itu, tubuh membutuhkan makanan di pagi hari sebagai sumber tenaga untuk bergerak, berpikir, dan belajar.\n\nSarapan membawa banyak manfaat bagi anak sekolah. Anak yang sarapan biasanya lebih mudah memusatkan perhatian saat guru menjelaskan pelajaran. Tubuhnya juga lebih bertenaga ketika berolahraga atau bermain bersama teman. Selain itu, anak yang sarapan tidak cepat merasa lapar sebelum jam istirahat tiba.\n\nSebaliknya, anak yang melewatkan sarapan sering merasa lemas dan mengantuk di kelas. Perutnya yang lapar membuat ia sulit berkonsentrasi. Selain itu, rasa lapar yang ditahan terlalu lama dapat membuat anak membeli jajanan sembarangan saat jam istirahat, padahal belum tentu jajanan itu sehat.\n\nSarapan yang baik tidak harus mahal atau rumit. Menu sederhana seperti nasi dengan telur dan sayur sudah mencukupi. Roti dengan selai kacang ditambah segelas susu atau sebuah pisang juga bisa menjadi pilihan. Yang penting, menu sarapan mengandung sumber tenaga, protein, serta vitamin.\n\nAgar tidak terlambat sarapan, bangunlah lebih pagi dan siapkan perlengkapan sekolah sejak malam hari. Dengan begitu, masih ada waktu untuk duduk dan makan bersama keluarga sebelum berangkat ke sekolah."
    },
    {
      "id": "pc-krayon",
      "jenis": "Teks Fiksi",
      "judul": "Krayon untuk Fikri",
      "teks": "Pagi itu, aula sekolah sudah ramai. Hari ini ada lomba menggambar antarkelas dengan tema “Kampungku yang Bersih”. Setiap peserta harus membawa alat gambarnya sendiri. Fikri duduk di barisan depan sambil membuka tasnya. Wajahnya mendadak pucat. Kotak krayon yang semalam ia siapkan ternyata tertinggal di meja belajarnya.\n\nNur, yang duduk di sebelahnya, melihat Fikri gelisah. “Kenapa, Fik? Kok bingung begitu?” tanyanya.\n\n“Krayonku ketinggalan, Nur. Padahal lombanya mulai lima menit lagi,” jawab Fikri lirih.\n\nNur membuka kotak krayonnya, lalu meletakkan kotak itu di antara meja mereka berdua. “Kita pakai bersama saja. Kalau kamu butuh warna yang sedang kupakai, bilang saja, nanti kita bergantian,” katanya. Fikri menatap Nur dengan lega.\n\nSelama lomba, mereka bergantian memakai krayon. Sesekali Nur harus menunggu karena warna biru sedang dipakai Fikri untuk mewarnai sungai. Meskipun begitu, Nur tidak mengeluh. Ia memakai waktu menunggu itu untuk merapikan garis gambarnya. Lama-kelamaan, gambar sungai Fikri tampak biru jernih dengan ikan-ikan kecil di dalamnya, sedangkan gambar Nur penuh dengan pohon yang rindang.\n\nKetika pengumuman pemenang, gambar Fikri mendapat juara ketiga. Fikri langsung menoleh kepada Nur. “Terima kasih, Nur. Tanpa krayonmu, aku tidak bisa ikut lomba.” Nur tersenyum lebar. “Sama-sama. Aku ikut senang, kok.”"
    },
    {
      "id": "pc-pohon",
      "jenis": "Teks Informasi",
      "judul": "Pohon Sahabat Kehidupan",
      "teks": "Pohon memiliki peran yang sangat penting bagi kehidupan di bumi. Melalui daunnya, pohon menyerap karbon dioksida dari udara dan menghasilkan oksigen yang kita hirup setiap saat. Oksigen sangat dibutuhkan oleh manusia dan hewan untuk bernapas. Itulah sebabnya, udara di tempat yang banyak pohonnya terasa lebih segar.\n\nSelain menyegarkan udara, pohon juga melindungi tanah. Akar pohon mencengkeram tanah dengan kuat sehingga tanah tidak mudah terbawa air hujan. Akar juga membantu air hujan meresap ke dalam tanah. Oleh karena itu, daerah yang banyak pohonnya lebih jarang mengalami tanah longsor dan banjir.\n\nPohon pun memberi manfaat yang langsung kita rasakan. Daunnya yang rimbun menjadi peneduh pada siang hari yang terik. Di bawahnya, kita dapat beristirahat dengan nyaman. Batang dan rantingnya menjadi tempat tinggal burung, tupai, dan berbagai serangga. Beberapa jenis pohon, seperti mangga dan rambutan, juga menghasilkan buah yang bisa dimakan.\n\nSayangnya, masih banyak pohon yang ditebang tanpa diganti dengan pohon baru. Kita dapat membantu menjaga jumlah pohon dengan cara sederhana, misalnya menanam pohon di halaman rumah atau sekolah. Jika halaman sempit, tanaman kecil di dalam pot pun tetap bermanfaat. Tanaman yang sudah ditanam juga perlu dirawat dengan disiram secara teratur."
    },
    {
      "id": "pc-nasi-goreng",
      "jenis": "Teks Fiksi",
      "judul": "Nasi Goreng Kejutan",
      "teks": "Minggu pagi itu, Ibu sudah berangkat sejak subuh untuk membuka warung di pasar. Siti dan adiknya, Akbar, berencana menyiapkan kejutan. Mereka ingin memasak nasi goreng untuk makan siang Ibu sepulang dari warung. Siti sudah sering melihat Ibu memasak, jadi ia yakin bisa melakukannya.\n\nSekitar pukul sepuluh, mereka mulai bekerja. Siti mengiris bawang, sedangkan Akbar bertugas menyiapkan piring dan mencuci sendok. Ketika Siti menumis bumbu, Akbar ingin membantu. Tanpa bertanya, ia menaburkan garam ke dalam wajan. Padahal, Siti sudah menambahkan garam sebelumnya.\n\nSiti mencicipi nasi gorengnya dan langsung meringis. “Aduh, asin sekali!” serunya. Akbar menunduk. “Maaf, Kak. Aku kira belum diberi garam,” katanya pelan.\n\nSiti menghela napas, lalu menepuk bahu adiknya. “Sudah, tidak apa-apa. Lain kali tanya dulu, ya. Sekarang kita cari jalan keluarnya.” Siti teringat cara Ibu mengurangi rasa asin, yaitu menambahkan nasi putih. Ia pun menambahkan sepiring nasi ke dalam wajan, lalu mengaduknya sampai rata. Sementara itu, Akbar membuat irisan mentimun dan tomat sebagai hiasan.\n\nSiang harinya, Ibu pulang dengan wajah lelah. Matanya berbinar saat melihat meja makan sudah tertata rapi. Ibu mencicipi nasi goreng itu dan tersenyum. “Enak sekali. Terima kasih, anak-anak. Masakan yang dibuat dengan kerja sama memang paling lezat,” kata Ibu."
    },
    {
      "id": "pc-lebah",
      "jenis": "Teks Informasi",
      "judul": "Kehidupan Lebah Madu",
      "teks": "Lebah madu adalah serangga yang hidup berkelompok dalam satu sarang. Satu sarang dapat dihuni oleh ribuan lebah. Setiap kelompok, atau koloni, dipimpin oleh seekor ratu lebah yang bertugas bertelur. Sebagian besar anggota koloni adalah lebah pekerja. Selain itu, ada lebah jantan yang jumlahnya jauh lebih sedikit.\n\nLebah pekerja memiliki banyak tugas. Mereka terbang dari bunga ke bunga untuk mengisap nektar, yaitu cairan manis di dalam bunga. Nektar itu dibawa pulang ke sarang dan diolah menjadi madu. Madu disimpan di dalam ruang-ruang kecil berbentuk segi enam yang terbuat dari lilin lebah. Lebah pekerja juga membersihkan sarang, merawat lebah muda, dan menjaga pintu sarang dari pengganggu.\n\nLebah pekerja punya cara unik untuk memberi tahu teman-temannya letak bunga yang banyak nektarnya. Sesampainya di sarang, lebah itu bergerak berputar-putar seperti sedang menari. Gerakan tarian tersebut menunjukkan arah dan jarak bunga kepada lebah lain.\n\nLebah juga sangat berjasa bagi tumbuhan. Ketika lebah hinggap di bunga, serbuk sari menempel pada tubuhnya yang berbulu. Serbuk sari itu kemudian terbawa ke bunga lain sehingga terjadi penyerbukan. Berkat penyerbukan, bunga dapat berkembang menjadi buah dan biji. Oleh karena itu, lebah perlu dilindungi, misalnya dengan tidak merusak sarangnya dan tidak menyemprotkan racun serangga sembarangan."
    },
    {
      "id": "pc-pot-bunga",
      "jenis": "Teks Fiksi",
      "judul": "Pot Bunga di Depan Kelas",
      "teks": "Jam istirahat hampir selesai. Yohanes dan Bayu masih bermain lempar bola kecil di lorong depan kelas, padahal Bu Wulan sudah melarang bermain bola di lorong. Ketika Yohanes melempar bola terlalu keras, bola itu mengenai pot bunga di dekat pintu. Pot tanah liat itu jatuh dan retak.\n\nBel masuk berbunyi. Teman-teman berlarian masuk kelas, dan tidak ada yang melihat kejadian tadi. Bayu berbisik, “Yo, diam saja. Tidak ada yang tahu, kok.”\n\nSelama pelajaran, Yohanes tidak bisa berkonsentrasi. Ia terus memikirkan pot bunga yang dirawat bersama oleh seluruh kelas itu. Hatinya tidak tenang. Ia tahu, menutupi kesalahan dengan diam tetap saja tidak jujur.\n\nKetika Bu Wulan bertanya siapa yang membuat pot itu retak, kelas menjadi hening. Yohanes menarik napas, lalu berdiri. “Saya, Bu. Saya bermain bola di lorong dan bolanya mengenai pot itu. Maafkan saya,” katanya dengan suara bergetar. Tak lama kemudian, Bayu ikut berdiri dan mengaku bahwa ia juga ikut bermain.\n\nBu Wulan tidak marah. Ia berterima kasih karena mereka berani mengaku. Namun, Bu Wulan meminta keduanya bertanggung jawab. Keesokan harinya, Yohanes dan Bayu membawa pot baru dari rumah dan memindahkan bunga itu dengan hati-hati. Sejak hari itu, mereka tidak pernah lagi bermain bola di lorong."
    }
  ],
  "soal": [
    {
      "id": "pc-sarapan-01",
      "bacaan": "pc-sarapan",
      "topik": "gagasan-pokok",
      "tipe": "pg",
      "teks": "Gagasan pokok paragraf ketiga teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Menu sarapan yang sederhana",
          "alasan": "Menu sarapan dibahas di **paragraf keempat**, bukan paragraf ketiga."
        },
        {
          "teks": "Semua jajanan di sekolah tidak sehat",
          "alasan": "Paragraf ketiga hanya menyebut jajanan sembarangan **belum tentu** sehat. Itu pun hanya satu rincian, bukan ide utama paragraf."
        },
        {
          "teks": "Akibat yang dialami anak jika melewatkan sarapan",
          "alasan": "Kalimat utama paragraf ketiga menyebut anak yang melewatkan sarapan sering **lemas dan mengantuk**. Kalimat berikutnya menambah akibat lain: sulit berkonsentrasi dan membeli jajanan sembarangan. Semuanya membahas **akibat tidak sarapan**."
        },
        {
          "teks": "Cara bangun lebih pagi",
          "alasan": "Bangun lebih pagi dibahas di **paragraf kelima** sebagai saran agar tidak terlambat sarapan."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Sebaliknya, anak yang melewatkan sarapan sering merasa lemas dan mengantuk di kelas.",
        "Perutnya yang lapar membuat ia sulit berkonsentrasi."
      ],
      "langkah": [
        {
          "teks": "Gagasan pokok adalah ide yang dibahas **seluruh** kalimat dalam paragraf. Paragraf ketiga diawali kata **Sebaliknya**, artinya paragraf ini membahas kebalikan dari paragraf kedua (manfaat sarapan)."
        },
        {
          "tanya": {
            "soal": "Kebalikan dari manfaat sarapan adalah …",
            "pilihan": [
              "Akibat tidak sarapan",
              "Menu sarapan",
              "Waktu sarapan"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Paragraf ketiga membahas apa yang terjadi kalau anak **tidak** sarapan."
        }
      ]
    },
    {
      "id": "pc-sarapan-02",
      "bacaan": "pc-sarapan",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Menurut teks, apa saja yang sering dialami anak yang melewatkan sarapan? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Merasa lemas",
          "benar": true,
          "alasan": "Disebut di paragraf ketiga: anak yang melewatkan sarapan sering merasa **lemas**."
        },
        {
          "teks": "Mengantuk di kelas",
          "benar": true,
          "alasan": "Disebut di kalimat yang sama: anak yang melewatkan sarapan sering **mengantuk di kelas**."
        },
        {
          "teks": "Sulit berkonsentrasi",
          "benar": true,
          "alasan": "Disebut di paragraf ketiga: perut yang lapar membuat anak **sulit berkonsentrasi**."
        },
        {
          "teks": "Tubuh lebih bertenaga saat berolahraga",
          "benar": false,
          "alasan": "Ini justru manfaat **sarapan** yang disebut di paragraf kedua, bukan akibat melewatkan sarapan."
        },
        {
          "teks": "Selalu sakit perut",
          "benar": false,
          "alasan": "Sakit perut tidak disebut di teks. Teks hanya menyebut perut yang **lapar**."
        }
      ],
      "bukti": [
        "Sebaliknya, anak yang melewatkan sarapan sering merasa lemas dan mengantuk di kelas.",
        "Perutnya yang lapar membuat ia sulit berkonsentrasi."
      ],
      "langkah": [
        {
          "teks": "Akibat melewatkan sarapan ada di **paragraf ketiga**. Hati-hati: paragraf kedua membahas kebalikannya, yaitu manfaat sarapan. Jangan sampai tertukar."
        }
      ]
    },
    {
      "id": "pc-sarapan-03",
      "bacaan": "pc-sarapan",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Frasa “memusatkan perhatian” pada paragraf kedua memiliki makna yang paling dekat dengan …",
      "pilihan": [
        {
          "teks": "Berkonsentrasi",
          "alasan": "Memusatkan perhatian berarti mengarahkan seluruh pikiran pada satu hal, yaitu **berkonsentrasi**. Kalimatnya tetap masuk akal: anak yang sarapan lebih mudah berkonsentrasi saat guru menjelaskan."
        },
        {
          "teks": "Mengalihkan pandangan",
          "alasan": "Mengalihkan pandangan berarti melihat ke arah lain. Ini justru kebalikan dari memperhatikan penjelasan guru."
        },
        {
          "teks": "Berbicara dengan teman",
          "alasan": "Berbicara dengan teman saat guru menjelaskan bukan memusatkan perhatian. Maknanya tidak cocok dengan kalimat."
        },
        {
          "teks": "Melupakan pelajaran",
          "alasan": "Melupakan pelajaran berlawanan dengan maksud kalimat yang membahas manfaat sarapan bagi belajar."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Anak yang sarapan biasanya lebih mudah memusatkan perhatian saat guru menjelaskan pelajaran."
      ],
      "langkah": [
        {
          "teks": "Ganti frasa “memusatkan perhatian” dengan setiap pilihan, lalu baca kalimatnya. Petunjuk lain ada di paragraf ketiga yang menyebut kebalikannya: anak yang lapar **sulit berkonsentrasi**."
        }
      ]
    },
    {
      "id": "pc-sarapan-04",
      "bacaan": "pc-sarapan",
      "topik": "kesesuaian-isi",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan teks.",
      "pernyataan": [
        {
          "teks": "Sarapan harus berupa makanan yang mahal.",
          "benar": false,
          "alasan": "Salah. Paragraf keempat menyebut sarapan yang baik **tidak harus mahal atau rumit**."
        },
        {
          "teks": "Nasi dengan telur dan sayur sudah termasuk menu sarapan yang mencukupi.",
          "benar": true,
          "alasan": "Benar. Paragraf keempat menyebut menu sederhana seperti nasi dengan telur dan sayur **sudah mencukupi**."
        },
        {
          "teks": "Menyiapkan perlengkapan sekolah sejak malam hari membantu anak tidak terlambat sarapan.",
          "benar": true,
          "alasan": "Benar. Paragraf kelima memberi saran ini **agar tidak terlambat sarapan**."
        },
        {
          "teks": "Teks menyebutkan bahwa semua jajanan di sekolah pasti tidak sehat.",
          "benar": false,
          "alasan": "Salah. Teks hanya berkata jajanan sembarangan **belum tentu** sehat. “Belum tentu sehat” tidak sama dengan “pasti tidak sehat”."
        }
      ],
      "bukti": [
        "Sarapan yang baik tidak harus mahal atau rumit.",
        "Menu sederhana seperti nasi dengan telur dan sayur sudah mencukupi.",
        "Agar tidak terlambat sarapan, bangunlah lebih pagi dan siapkan perlengkapan sekolah sejak malam hari."
      ],
      "langkah": [
        {
          "teks": "Periksa pernyataan **satu per satu**. Perhatikan kata-kata kecil seperti **harus**, **pasti**, dan **belum tentu**, karena kata-kata itu bisa mengubah makna kalimat."
        },
        {
          "tanya": {
            "soal": "Kalimat “jajanan itu belum tentu sehat” artinya …",
            "pilihan": [
              "Jajanan itu pasti tidak sehat",
              "Jajanan itu bisa sehat, bisa juga tidak"
            ],
            "jawaban": "B"
          },
          "setelah": "Tepat. Jadi pernyataan “semua jajanan pasti tidak sehat” tidak sesuai dengan teks."
        }
      ]
    },
    {
      "id": "pc-sarapan-05",
      "bacaan": "pc-sarapan",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa tubuh membutuhkan makanan di pagi hari, menurut teks?",
      "pilihan": [
        {
          "teks": "Karena sarapan harus dilakukan bersama keluarga",
          "alasan": "Makan bersama keluarga disebut di paragraf terakhir sebagai hal yang menyenangkan, bukan alasan tubuh membutuhkan makanan."
        },
        {
          "teks": "Karena anak harus membeli jajanan saat istirahat",
          "alasan": "Teks tidak mengharuskan anak membeli jajanan. Jajanan sembarangan justru disebut belum tentu sehat."
        },
        {
          "teks": "Karena tidur membuat tubuh menjadi gemuk",
          "alasan": "Teks sama sekali tidak menyebut tidur membuat tubuh gemuk."
        },
        {
          "teks": "Karena perut kosong selama berjam-jam setelah tidur sepanjang malam",
          "alasan": "Paragraf pertama menjelaskan: setelah tidur sepanjang malam, perut **kosong selama berjam-jam**. **Karena itu**, tubuh membutuhkan makanan sebagai sumber tenaga."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Setelah tidur sepanjang malam, perut kita kosong selama berjam-jam.",
        "Karena itu, tubuh membutuhkan makanan di pagi hari sebagai sumber tenaga untuk bergerak, berpikir, dan belajar."
      ],
      "langkah": [
        {
          "teks": "Frasa **Karena itu** menunjukkan bahwa kalimat sebelumnya adalah **sebab**. Baca kalimat tepat sebelum “Karena itu” di paragraf pertama."
        },
        {
          "tanya": {
            "soal": "Kalimat sebelum “Karena itu” menyebutkan bahwa setelah tidur sepanjang malam, perut kita …",
            "pilihan": [
              "Kenyang sekali",
              "Kosong selama berjam-jam",
              "Sakit"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Perut yang kosong itulah **sebab** tubuh membutuhkan makanan di pagi hari."
        }
      ]
    },
    {
      "id": "pc-sarapan-06",
      "bacaan": "pc-sarapan",
      "topik": "simpulan",
      "tipe": "pg",
      "teks": "Simpulan yang tepat berdasarkan seluruh isi teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Sarapan hanya penting bagi anak yang suka berolahraga",
          "alasan": "Terlalu sempit dan tidak sesuai teks. Sarapan penting bagi **semua** anak sekolah, untuk belajar maupun bermain."
        },
        {
          "teks": "Sarapan memberi tenaga untuk belajar dan beraktivitas, serta dapat disiapkan dengan menu sederhana",
          "alasan": "Pilihan ini merangkum isi seluruh teks: alasan perlu sarapan (paragraf 1), manfaat dan akibat tidak sarapan (paragraf 2–3), menu sederhana (paragraf 4), dan cara agar sempat sarapan (paragraf 5)."
        },
        {
          "teks": "Anak boleh melewatkan sarapan asalkan membeli jajanan saat istirahat",
          "alasan": "Bertentangan dengan teks. Melewatkan sarapan membuat anak lemas, dan jajanan sembarangan belum tentu sehat."
        },
        {
          "teks": "Sarapan sebaiknya dilakukan di sekolah",
          "alasan": "Teks menyarankan sarapan bersama keluarga **sebelum berangkat** ke sekolah."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Karena itu, tubuh membutuhkan makanan di pagi hari sebagai sumber tenaga untuk bergerak, berpikir, dan belajar.",
        "Sarapan yang baik tidak harus mahal atau rumit."
      ],
      "langkah": [
        {
          "teks": "Simpulan harus mewakili **seluruh** teks. Coret dulu pilihan yang bertentangan dengan teks, lalu pilih yang mencakup paling banyak isi teks."
        }
      ]
    },
    {
      "id": "pc-krayon-01",
      "bacaan": "pc-krayon",
      "topik": "latar",
      "tipe": "pg",
      "teks": "Di mana sebagian besar peristiwa dalam cerita tersebut terjadi?",
      "pilihan": [
        {
          "teks": "Di kamar Fikri",
          "alasan": "Meja belajar Fikri hanya disebut sebagai tempat krayon tertinggal. Peristiwanya sendiri tidak terjadi di kamar."
        },
        {
          "teks": "Di aula sekolah saat lomba menggambar",
          "alasan": "Cerita dimulai di **aula sekolah** yang ramai karena ada **lomba menggambar**, dan semua peristiwa (krayon tertinggal, berbagi krayon, pengumuman juara) terjadi di sana."
        },
        {
          "teks": "Di tepi sungai kampung",
          "alasan": "Sungai hanya bagian dari gambar yang diwarnai Fikri, bukan tempat terjadinya cerita."
        },
        {
          "teks": "Di ruang guru",
          "alasan": "Ruang guru tidak disebut di cerita."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Pagi itu, aula sekolah sudah ramai. Hari ini ada lomba menggambar antarkelas dengan tema “Kampungku yang Bersih”."
      ],
      "langkah": [
        {
          "teks": "Latar tempat biasanya disebut di **awal cerita**. Hati-hati dengan tempat yang hanya disebut sekilas atau yang ada di dalam gambar, karena peristiwa tidak terjadi di sana."
        },
        {
          "tanya": {
            "soal": "Di mana Fikri duduk saat membuka tasnya?",
            "pilihan": [
              "Di barisan depan aula",
              "Di meja belajar di rumah"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Fikri sudah berada di aula. Meja belajar hanya tempat krayonnya tertinggal."
        }
      ]
    },
    {
      "id": "pc-krayon-02",
      "bacaan": "pc-krayon",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Apa masalah yang dialami Fikri pada awal cerita?",
      "pilihan": [
        {
          "teks": "Fikri tidak tahu tema lomba",
          "alasan": "Tema lomba disebut dengan jelas, yaitu “Kampungku yang Bersih”. Fikri tidak bermasalah dengan tema."
        },
        {
          "teks": "Fikri bertengkar dengan Nur",
          "alasan": "Fikri dan Nur tidak bertengkar. Nur justru membantu Fikri."
        },
        {
          "teks": "Fikri terlambat datang ke aula",
          "alasan": "Fikri tidak terlambat. Ia sudah duduk di barisan depan sebelum lomba dimulai."
        },
        {
          "teks": "Krayon Fikri tertinggal di rumah padahal lomba segera dimulai",
          "alasan": "Paragraf pertama: kotak krayon Fikri **tertinggal di meja belajarnya**. Fikri juga berkata lomba **mulai lima menit lagi**. Inilah masalahnya."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Kotak krayon yang semalam ia siapkan ternyata tertinggal di meja belajarnya.",
        "“Krayonku ketinggalan, Nur. Padahal lombanya mulai lima menit lagi,” jawab Fikri lirih."
      ],
      "langkah": [
        {
          "teks": "Masalah di awal cerita adalah kejadian yang membuat tokoh kesulitan. Perhatikan kalimat **Wajahnya mendadak pucat**, lalu baca kalimat sesudahnya untuk tahu apa penyebabnya."
        }
      ]
    },
    {
      "id": "pc-krayon-03",
      "bacaan": "pc-krayon",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Kalimat “Wajahnya mendadak pucat” menunjukkan bahwa Fikri merasa …",
      "pilihan": [
        {
          "teks": "Senang karena akan ikut lomba",
          "alasan": "Wajah pucat bukan tanda senang. Lagi pula, kalimat sesudahnya menceritakan krayonnya tertinggal."
        },
        {
          "teks": "Marah kepada Nur",
          "alasan": "Saat itu Nur belum berbicara dengan Fikri, jadi tidak ada alasan Fikri marah kepada Nur."
        },
        {
          "teks": "Cemas dan panik",
          "alasan": "Wajah pucat sering muncul saat seseorang kaget dan cemas. Fikri panik karena krayonnya **tertinggal** padahal lomba segera mulai. Nur pun melihat Fikri **gelisah**."
        },
        {
          "teks": "Mengantuk karena kurang tidur",
          "alasan": "Cerita tidak menyebut Fikri mengantuk atau kurang tidur."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Wajahnya mendadak pucat. Kotak krayon yang semalam ia siapkan ternyata tertinggal di meja belajarnya.",
        "Nur, yang duduk di sebelahnya, melihat Fikri gelisah."
      ],
      "langkah": [
        {
          "teks": "Perasaan tokoh bisa disimpulkan dari **ekspresi wajah** dan **kejadian** di sekitarnya. Baca kalimat sesudah “Wajahnya mendadak pucat”."
        },
        {
          "tanya": {
            "soal": "Nur melihat Fikri “gelisah”. Gelisah artinya …",
            "pilihan": [
              "Tidak tenang",
              "Gembira sekali",
              "Mengantuk"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Fikri tidak tenang karena krayonnya tertinggal. Ia merasa **cemas dan panik**."
        }
      ]
    },
    {
      "id": "pc-krayon-04",
      "bacaan": "pc-krayon",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Sifat-sifat Nur yang tergambar dalam cerita tersebut adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Suka berbagi",
          "benar": true,
          "alasan": "Nur meletakkan kotak krayonnya di antara meja mereka dan berkata, “Kita pakai bersama saja.”"
        },
        {
          "teks": "Sabar",
          "benar": true,
          "alasan": "Nur harus menunggu saat warna biru dipakai Fikri, tetapi ia **tidak mengeluh** dan memakai waktu itu untuk merapikan gambarnya."
        },
        {
          "teks": "Peduli terhadap teman",
          "benar": true,
          "alasan": "Nur memperhatikan Fikri yang gelisah dan langsung bertanya, “Kenapa, Fik?” Ia juga ikut senang saat Fikri menang."
        },
        {
          "teks": "Pelit",
          "benar": false,
          "alasan": "Kebalikan dari sikap Nur. Ia justru berbagi krayonnya."
        },
        {
          "teks": "Suka pamer",
          "benar": false,
          "alasan": "Tidak ada bagian cerita yang menunjukkan Nur memamerkan krayon atau gambarnya."
        }
      ],
      "bukti": [
        "“Kita pakai bersama saja. Kalau kamu butuh warna yang sedang kupakai, bilang saja, nanti kita bergantian,” katanya.",
        "Meskipun begitu, Nur tidak mengeluh.",
        "Nur, yang duduk di sebelahnya, melihat Fikri gelisah. “Kenapa, Fik? Kok bingung begitu?” tanyanya."
      ],
      "langkah": [
        {
          "teks": "Untuk setiap sifat, cari **perbuatan** atau **ucapan** Nur yang menjadi buktinya. Sifat yang tidak punya bukti di cerita jangan dipilih."
        }
      ]
    },
    {
      "id": "pc-krayon-05",
      "bacaan": "pc-krayon",
      "topik": "alur-peristiwa",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan cerita.",
      "pernyataan": [
        {
          "teks": "Nur memberikan semua krayonnya kepada Fikri dan tidak ikut menggambar.",
          "benar": false,
          "alasan": "Salah. Nur tetap menggambar. Krayon itu **dipakai bersama** dan **bergantian**, bahkan Nur sempat merapikan garis gambarnya."
        },
        {
          "teks": "Fikri dan Nur bergantian memakai krayon selama lomba.",
          "benar": true,
          "alasan": "Benar. Paragraf kelima: selama lomba, mereka **bergantian** memakai krayon."
        },
        {
          "teks": "Nur pernah menunggu karena warna biru sedang dipakai Fikri.",
          "benar": true,
          "alasan": "Benar. Fikri memakai warna biru untuk mewarnai sungai, sehingga Nur harus menunggu."
        },
        {
          "teks": "Gambar Nur mendapat juara ketiga.",
          "benar": false,
          "alasan": "Salah. Yang mendapat juara ketiga adalah **gambar Fikri**."
        }
      ],
      "bukti": [
        "Selama lomba, mereka bergantian memakai krayon. Sesekali Nur harus menunggu karena warna biru sedang dipakai Fikri untuk mewarnai sungai.",
        "Ketika pengumuman pemenang, gambar Fikri mendapat juara ketiga."
      ],
      "langkah": [
        {
          "teks": "Untuk setiap pernyataan, cari bagian cerita yang membahas hal yang sama. Perhatikan **siapa** yang melakukan sesuatu, karena pernyataan bisa salah hanya karena nama tokohnya tertukar."
        },
        {
          "tanya": {
            "soal": "Gambar siapa yang mendapat juara ketiga?",
            "pilihan": [
              "Gambar Nur",
              "Gambar Fikri"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul, gambar **Fikri**. Jadi pernyataan terakhir salah karena nama tokohnya tertukar."
        }
      ]
    },
    {
      "id": "pc-krayon-06",
      "bacaan": "pc-krayon",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Kita sebaiknya mau berbagi dengan teman yang sedang kesulitan, walaupun harus sedikit berkorban",
          "alasan": "Nur berbagi krayon dan rela menunggu giliran agar Fikri bisa ikut lomba. Ini pesan baik yang berlaku untuk semua pembaca."
        },
        {
          "teks": "Kita harus selalu menang dalam setiap lomba",
          "alasan": "Cerita tidak mengajarkan bahwa menang itu wajib. Yang ditonjolkan adalah kebaikan Nur, bukan kemenangan."
        },
        {
          "teks": "Barang milik sendiri sebaiknya tidak dipinjamkan agar tidak rusak",
          "alasan": "Bertentangan dengan cerita. Berbagi krayon justru digambarkan sebagai perbuatan baik."
        },
        {
          "teks": "Lomba menggambar hanya untuk anak yang membawa krayon lengkap",
          "alasan": "Bukan pesan cerita. Fikri tetap bisa ikut lomba berkat bantuan Nur."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Kita pakai bersama saja.",
        "Meskipun begitu, Nur tidak mengeluh.",
        "“Terima kasih, Nur. Tanpa krayonmu, aku tidak bisa ikut lomba.”"
      ],
      "langkah": [
        {
          "teks": "Amanat dilihat dari **sikap baik tokoh** dan **akhir cerita**. Di akhir cerita, Fikri berkata ia tidak bisa ikut lomba tanpa krayon Nur. Apa sikap baik Nur yang membuat itu terjadi?"
        }
      ]
    },
    {
      "id": "pc-pohon-01",
      "bacaan": "pc-pohon",
      "topik": "topik-judul",
      "tipe": "pg",
      "teks": "Topik utama yang dibahas dalam teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Cara menyiram tanaman",
          "alasan": "Menyiram tanaman hanya disebut sekilas di kalimat terakhir. Terlalu sempit untuk menjadi topik seluruh teks."
        },
        {
          "teks": "Hewan yang tinggal di pohon",
          "alasan": "Burung, tupai, dan serangga hanya disebut sebagai salah satu manfaat pohon di paragraf ketiga."
        },
        {
          "teks": "Manfaat pohon dan cara menjaga jumlahnya",
          "alasan": "Pilihan ini mencakup **seluruh** teks: manfaat pohon bagi udara (paragraf 1), tanah (paragraf 2), dan kehidupan sehari-hari (paragraf 3), serta cara menjaga jumlah pohon (paragraf 4)."
        },
        {
          "teks": "Jenis-jenis pohon buah",
          "alasan": "Teks hanya menyebut mangga dan rambutan sebagai contoh. Teks tidak membahas jenis-jenis pohon buah."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Pohon memiliki peran yang sangat penting bagi kehidupan di bumi.",
        "Kita dapat membantu menjaga jumlah pohon dengan cara sederhana, misalnya menanam pohon di halaman rumah atau sekolah."
      ],
      "langkah": [
        {
          "teks": "Topik utama harus mencakup isi **semua** paragraf. Coba ingat inti tiap paragraf, lalu cari pilihan yang memuat semuanya."
        },
        {
          "tanya": {
            "soal": "Paragraf pertama sampai ketiga sama-sama membahas …",
            "pilihan": [
              "Manfaat pohon",
              "Cara menanam pohon",
              "Bahaya menebang pohon"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Paragraf 1–3 membahas manfaat pohon, dan paragraf 4 membahas cara menjaga jumlah pohon."
        }
      ]
    },
    {
      "id": "pc-pohon-02",
      "bacaan": "pc-pohon",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “mencengkeram” pada paragraf kedua bermakna …",
      "pilihan": [
        {
          "teks": "Melepaskan pelan-pelan",
          "alasan": "Kebalikan dari maksud kalimat. Jika akar melepaskan tanah, tanah justru mudah terbawa air hujan."
        },
        {
          "teks": "Menyiram dengan air",
          "alasan": "Akar tidak menyiram tanah. Kalimatnya menjadi tidak masuk akal."
        },
        {
          "teks": "Menggali lubang",
          "alasan": "Menggali lubang tidak membuat tanah lebih kuat. Maknanya tidak cocok dengan lanjutan kalimat."
        },
        {
          "teks": "Memegang dengan erat",
          "alasan": "Akar **memegang tanah dengan erat** sehingga tanah tidak mudah terbawa air hujan. Kata “dengan kuat” di kalimat itu juga menjadi petunjuk."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Akar pohon mencengkeram tanah dengan kuat sehingga tanah tidak mudah terbawa air hujan."
      ],
      "langkah": [
        {
          "teks": "Baca kalimat lengkapnya. Kata **dengan kuat** dan akibatnya, **tanah tidak mudah terbawa air hujan**, memberi petunjuk arti “mencengkeram”."
        }
      ]
    },
    {
      "id": "pc-pohon-03",
      "bacaan": "pc-pohon",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Mengapa daerah yang banyak pohonnya lebih jarang mengalami tanah longsor, berdasarkan teks?",
      "pilihan": [
        {
          "teks": "Karena pohon menghasilkan buah yang bisa dimakan",
          "alasan": "Buah memang manfaat pohon (paragraf ketiga), tetapi tidak ada hubungannya dengan tanah longsor."
        },
        {
          "teks": "Karena akar pohon mencengkeram tanah sehingga tanah tidak mudah terbawa air hujan",
          "alasan": "Paragraf kedua menjelaskan fungsi akar ini, lalu menutup dengan **Oleh karena itu**, daerah yang banyak pohonnya lebih jarang mengalami tanah longsor."
        },
        {
          "teks": "Karena daun yang rimbun menjadi peneduh",
          "alasan": "Peneduh adalah manfaat lain pohon (paragraf ketiga) dan tidak berhubungan dengan longsor."
        },
        {
          "teks": "Karena burung tinggal di ranting pohon",
          "alasan": "Tempat tinggal burung tidak berhubungan dengan longsor. Pilihan ini benar sebagai fakta, tetapi bukan jawaban pertanyaannya."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Akar pohon mencengkeram tanah dengan kuat sehingga tanah tidak mudah terbawa air hujan.",
        "Oleh karena itu, daerah yang banyak pohonnya lebih jarang mengalami tanah longsor dan banjir."
      ],
      "langkah": [
        {
          "teks": "Hati-hati: semua pilihan menyebut manfaat pohon yang ada di teks, tetapi hanya satu yang **menyebabkan** tanah tidak longsor. Cari paragraf yang menyebut kata **longsor**."
        },
        {
          "tanya": {
            "soal": "Bagian tubuh pohon mana yang menahan tanah?",
            "pilihan": [
              "Daun",
              "Akar",
              "Buah"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul, **akar**. Akar mencengkeram tanah sehingga tanah tidak mudah terbawa air hujan."
        }
      ]
    },
    {
      "id": "pc-pohon-04",
      "bacaan": "pc-pohon",
      "topik": "kalimat-utama",
      "tipe": "pg",
      "acakPilihan": false,
      "teks": "Kalimat utama paragraf ketiga adalah …",
      "pilihan": [
        {
          "teks": "Pohon pun memberi manfaat yang langsung kita rasakan.",
          "alasan": "Kalimat ini berisi ide utama paragraf. Kalimat-kalimat berikutnya memberi **contoh** manfaat yang langsung dirasakan: peneduh, tempat tinggal hewan, dan buah."
        },
        {
          "teks": "Daunnya yang rimbun menjadi peneduh pada siang hari yang terik.",
          "alasan": "Ini kalimat penjelas. Ia hanya memberi satu contoh manfaat, yaitu peneduh."
        },
        {
          "teks": "Batang dan rantingnya menjadi tempat tinggal burung, tupai, dan berbagai serangga.",
          "alasan": "Ini kalimat penjelas yang memberi satu contoh manfaat lain."
        },
        {
          "teks": "Beberapa jenis pohon, seperti mangga dan rambutan, juga menghasilkan buah yang bisa dimakan.",
          "alasan": "Ini kalimat penjelas yang memberi contoh terakhir. Kata **juga** menandakan kalimat ini menambah rincian."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Pohon pun memberi manfaat yang langsung kita rasakan."
      ],
      "langkah": [
        {
          "teks": "Kalimat utama bersifat **umum**, sedangkan kalimat penjelas berisi **contoh atau rincian**. Cari kalimat yang dijelaskan oleh kalimat-kalimat lainnya."
        },
        {
          "tanya": {
            "soal": "Peneduh, tempat tinggal burung, dan buah adalah contoh dari …",
            "pilihan": [
              "Manfaat pohon yang langsung kita rasakan",
              "Cara menanam pohon"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Karena ketiganya contoh dari kalimat pertama, kalimat pertama adalah kalimat utamanya."
        }
      ]
    },
    {
      "id": "pc-pohon-05",
      "bacaan": "pc-pohon",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Cara sederhana menjaga jumlah pohon yang disebutkan dalam teks adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Menanam pohon di halaman rumah atau sekolah",
          "benar": true,
          "alasan": "Disebut di paragraf keempat sebagai contoh cara sederhana menjaga jumlah pohon."
        },
        {
          "teks": "Menanam tanaman kecil di dalam pot jika halaman sempit",
          "benar": true,
          "alasan": "Disebut di paragraf keempat: jika halaman sempit, tanaman kecil di dalam pot pun tetap bermanfaat."
        },
        {
          "teks": "Merawat tanaman dengan menyiramnya secara teratur",
          "benar": true,
          "alasan": "Disebut di kalimat terakhir: tanaman yang sudah ditanam perlu dirawat dengan disiram secara teratur."
        },
        {
          "teks": "Menebang pohon tua tanpa menggantinya",
          "benar": false,
          "alasan": "Kebalikan dari teks. Menebang pohon tanpa diganti justru disebut sebagai hal yang disayangkan."
        },
        {
          "teks": "Memetik buah mangga sebanyak-banyaknya",
          "benar": false,
          "alasan": "Memetik buah tidak disebut sebagai cara menjaga jumlah pohon."
        }
      ],
      "bukti": [
        "Kita dapat membantu menjaga jumlah pohon dengan cara sederhana, misalnya menanam pohon di halaman rumah atau sekolah.",
        "Jika halaman sempit, tanaman kecil di dalam pot pun tetap bermanfaat.",
        "Tanaman yang sudah ditanam juga perlu dirawat dengan disiram secara teratur."
      ],
      "langkah": [
        {
          "teks": "Cara menjaga jumlah pohon dibahas di **paragraf keempat**. Baca paragraf itu sampai kalimat terakhir, karena ada cara yang disebut di ujung paragraf."
        }
      ]
    },
    {
      "id": "pc-pohon-06",
      "bacaan": "pc-pohon",
      "topik": "sikap-refleksi",
      "tipe": "pg",
      "teks": "Contoh sikap yang sesuai dengan isi teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Mematahkan ranting pohon untuk bermain",
          "alasan": "Merusak pohon bertentangan dengan pesan teks yang mengajak menjaga pohon. Ranting juga tempat tinggal hewan."
        },
        {
          "teks": "Menebang pohon peneduh agar halaman lebih terang",
          "alasan": "Bertentangan dengan teks yang menyayangkan pohon ditebang tanpa diganti."
        },
        {
          "teks": "Mengajak teman menanam dan merawat pohon di halaman sekolah",
          "alasan": "Sejalan dengan saran paragraf keempat: menanam pohon di halaman rumah atau sekolah, lalu merawatnya."
        },
        {
          "teks": "Menanam pohon, lalu membiarkannya tanpa disiram",
          "alasan": "Tidak sesuai, karena teks menyebut tanaman yang sudah ditanam **perlu dirawat** dengan disiram secara teratur."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Kita dapat membantu menjaga jumlah pohon dengan cara sederhana, misalnya menanam pohon di halaman rumah atau sekolah.",
        "Tanaman yang sudah ditanam juga perlu dirawat dengan disiram secara teratur."
      ],
      "langkah": [
        {
          "teks": "Sikap yang tepat harus **sejalan dengan saran** di paragraf terakhir. Ada dua saran penting: menanam dan merawat. Pilihan yang hanya melakukan setengahnya belum tepat."
        }
      ]
    },
    {
      "id": "pc-nasi-01",
      "bacaan": "pc-nasi-goreng",
      "topik": "tokoh",
      "tipe": "pg",
      "teks": "Siapa tokoh yang menaburkan garam ke dalam wajan tanpa bertanya?",
      "pilihan": [
        {
          "teks": "Siti",
          "alasan": "Siti memang sudah menambahkan garam, tetapi ia tidak melakukannya “tanpa bertanya”. Yang menaburkan garam tanpa bertanya adalah adiknya."
        },
        {
          "teks": "Ibu",
          "alasan": "Ibu sedang berada di warung saat Siti dan Akbar memasak."
        },
        {
          "teks": "Akbar",
          "alasan": "Paragraf kedua: Akbar ingin membantu, lalu **tanpa bertanya** ia menaburkan garam ke dalam wajan."
        },
        {
          "teks": "Nenek",
          "alasan": "Tidak ada tokoh nenek di cerita ini."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Tanpa bertanya, ia menaburkan garam ke dalam wajan."
      ],
      "langkah": [
        {
          "teks": "Cari kalimat yang memuat kata **tanpa bertanya**. Kata “ia” di kalimat itu merujuk pada tokoh yang disebut di kalimat sebelumnya."
        },
        {
          "tanya": {
            "soal": "Kalimat sebelumnya berbunyi “Ketika Siti menumis bumbu, Akbar ingin membantu.” Siapa yang ingin membantu?",
            "pilihan": [
              "Siti",
              "Akbar"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Jadi kata “ia” merujuk pada **Akbar**."
        }
      ]
    },
    {
      "id": "pc-nasi-02",
      "bacaan": "pc-nasi-goreng",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Mengapa nasi goreng buatan Siti dan Akbar terasa asin?",
      "pilihan": [
        {
          "teks": "Karena Ibu menambahkan garam saat pulang",
          "alasan": "Ibu baru pulang siang hari dan langsung mencicipi. Ibu tidak menambahkan garam."
        },
        {
          "teks": "Karena garam ditambahkan dua kali, oleh Siti dan oleh Akbar",
          "alasan": "Paragraf kedua: Akbar menaburkan garam, **padahal Siti sudah menambahkan garam sebelumnya**. Garamnya jadi dua kali."
        },
        {
          "teks": "Karena Siti salah mengira gula sebagai garam",
          "alasan": "Cerita tidak menyebut gula sama sekali."
        },
        {
          "teks": "Karena bawang yang diiris terlalu banyak",
          "alasan": "Bawang tidak membuat masakan asin, dan cerita tidak menyebut bawangnya terlalu banyak."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Tanpa bertanya, ia menaburkan garam ke dalam wajan. Padahal, Siti sudah menambahkan garam sebelumnya."
      ],
      "langkah": [
        {
          "teks": "Perhatikan kata **Padahal** di paragraf kedua. Kata itu menunjukkan ada hal yang sudah terjadi sebelumnya, yang membuat tindakan Akbar menjadi masalah."
        }
      ]
    },
    {
      "id": "pc-nasi-03",
      "bacaan": "pc-nasi-goreng",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “meringis” pada kalimat “Siti mencicipi nasi gorengnya dan langsung meringis” paling tepat diartikan …",
      "pilihan": [
        {
          "teks": "Menarik bibir sehingga gigi terlihat karena merasakan sesuatu yang tidak enak",
          "alasan": "Siti meringis lalu berseru “Aduh, asin sekali!”. Ekspresi itu muncul karena ia merasakan rasa yang **tidak enak**."
        },
        {
          "teks": "Tertawa terbahak-bahak karena senang",
          "alasan": "Seruan “Aduh, asin sekali!” menunjukkan Siti tidak sedang senang."
        },
        {
          "teks": "Menangis tersedu-sedu",
          "alasan": "Siti tidak menangis. Ia hanya terkejut dengan rasa asin, lalu tetap tenang mencari jalan keluar."
        },
        {
          "teks": "Bernyanyi dengan riang",
          "alasan": "Tidak cocok dengan suasana kalimat. Siti baru saja merasakan masakannya terlalu asin."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Siti mencicipi nasi gorengnya dan langsung meringis. “Aduh, asin sekali!” serunya."
      ],
      "langkah": [
        {
          "teks": "Arti kata bisa ditebak dari **kalimat sesudahnya**. Baca apa yang diucapkan Siti tepat setelah ia meringis."
        }
      ]
    },
    {
      "id": "pc-nasi-04",
      "bacaan": "pc-nasi-goreng",
      "topik": "watak",
      "tipe": "pg",
      "teks": "Sikap Siti saat mengetahui kesalahan adiknya menunjukkan bahwa ia adalah kakak yang …",
      "pilihan": [
        {
          "teks": "Pemarah dan suka menyalahkan",
          "alasan": "Siti tidak marah. Ia menepuk bahu Akbar dan berkata, “Sudah, tidak apa-apa.”"
        },
        {
          "teks": "Tidak peduli pada masakannya",
          "alasan": "Siti peduli. Ia langsung mencari cara agar nasi goreng tidak terlalu asin."
        },
        {
          "teks": "Mudah menyerah",
          "alasan": "Siti tidak menyerah. Ia berkata, “Sekarang kita cari jalan keluarnya,” lalu memperbaiki masakannya."
        },
        {
          "teks": "Sabar dan pandai mencari jalan keluar",
          "alasan": "Siti **menghela napas**, menenangkan adiknya, lalu teringat cara Ibu mengurangi rasa asin dan **menambahkan nasi putih**. Ia sabar dan bisa menyelesaikan masalah."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Siti menghela napas, lalu menepuk bahu adiknya. “Sudah, tidak apa-apa. Lain kali tanya dulu, ya. Sekarang kita cari jalan keluarnya.”",
        "Ia pun menambahkan sepiring nasi ke dalam wajan, lalu mengaduknya sampai rata."
      ],
      "langkah": [
        {
          "teks": "Watak tokoh terlihat dari **ucapan** dan **tindakannya**. Lihat apa yang Siti katakan kepada Akbar, lalu apa yang ia lakukan pada nasi goreng."
        },
        {
          "tanya": {
            "soal": "Setelah tahu nasi gorengnya asin, Siti …",
            "pilihan": [
              "Memarahi Akbar",
              "Mencari cara memperbaikinya",
              "Berhenti memasak"
            ],
            "jawaban": "B"
          },
          "setelah": "Tepat. Siti tetap tenang dan mencari cara memperbaikinya. Ia kakak yang **sabar** dan **pandai mencari jalan keluar**."
        }
      ]
    },
    {
      "id": "pc-nasi-05",
      "bacaan": "pc-nasi-goreng",
      "topik": "alur-peristiwa",
      "tipe": "mcma",
      "teks": "Apa saja yang dilakukan Siti setelah mengetahui nasi gorengnya terlalu asin? Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Menepuk bahu Akbar dan memaafkannya",
          "benar": true,
          "alasan": "Paragraf keempat: Siti menepuk bahu adiknya dan berkata, “Sudah, tidak apa-apa.”"
        },
        {
          "teks": "Menambahkan nasi putih ke dalam wajan",
          "benar": true,
          "alasan": "Siti teringat cara Ibu, lalu menambahkan sepiring nasi ke dalam wajan dan mengaduknya."
        },
        {
          "teks": "Membuang nasi goreng itu",
          "benar": false,
          "alasan": "Nasi goreng tidak dibuang. Siti memperbaikinya, dan Ibu memakannya di akhir cerita."
        },
        {
          "teks": "Menelepon Ibu untuk meminta bantuan",
          "benar": false,
          "alasan": "Siti tidak menelepon Ibu. Ia **teringat** cara Ibu mengurangi rasa asin."
        },
        {
          "teks": "Membuat irisan mentimun dan tomat",
          "benar": false,
          "alasan": "Yang membuat irisan mentimun dan tomat adalah **Akbar**, bukan Siti."
        }
      ],
      "bukti": [
        "Siti menghela napas, lalu menepuk bahu adiknya.",
        "Siti teringat cara Ibu mengurangi rasa asin, yaitu menambahkan nasi putih.",
        "Sementara itu, Akbar membuat irisan mentimun dan tomat sebagai hiasan."
      ],
      "langkah": [
        {
          "teks": "Semua tindakan setelah nasi goreng terasa asin ada di **paragraf keempat**. Perhatikan **siapa** yang melakukan setiap tindakan, karena ada tindakan Akbar juga di paragraf itu."
        }
      ]
    },
    {
      "id": "pc-nasi-06",
      "bacaan": "pc-nasi-goreng",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Garam sebaiknya tidak dipakai dalam masakan",
          "alasan": "Bukan pesan cerita. Masalahnya bukan karena memakai garam, tetapi karena garamnya ditambahkan dua kali tanpa bertanya."
        },
        {
          "teks": "Anak-anak tidak boleh memasak di dapur",
          "alasan": "Bertentangan dengan cerita. Siti dan Akbar berhasil membuat kejutan yang membuat Ibu senang."
        },
        {
          "teks": "Kesalahan sebaiknya dimaafkan, lalu diperbaiki bersama-sama",
          "alasan": "Siti memaafkan Akbar dan mereka memperbaiki masakan bersama. Ibu pun menegaskan bahwa masakan yang dibuat dengan **kerja sama** paling lezat."
        },
        {
          "teks": "Kejutan hanya boleh dibuat oleh orang dewasa",
          "alasan": "Bertentangan dengan cerita. Kejutan dari Siti dan Akbar justru membuat Ibu senang."
        }
      ],
      "kunci": "C",
      "bukti": [
        "“Sudah, tidak apa-apa. Lain kali tanya dulu, ya. Sekarang kita cari jalan keluarnya.”",
        "Masakan yang dibuat dengan kerja sama memang paling lezat,"
      ],
      "langkah": [
        {
          "teks": "Amanat sering ditegaskan lewat **ucapan tokoh dewasa** di akhir cerita. Baca lagi ucapan Ibu, lalu hubungkan dengan sikap Siti kepada Akbar."
        },
        {
          "tanya": {
            "soal": "Menurut Ibu, masakan yang paling lezat adalah masakan yang dibuat dengan …",
            "pilihan": [
              "Banyak garam",
              "Kerja sama",
              "Bahan mahal"
            ],
            "jawaban": "B"
          },
          "setelah": "Tepat. Ucapan Ibu menegaskan pesan cerita: kesalahan dimaafkan, lalu diperbaiki **bersama-sama**."
        }
      ]
    },
    {
      "id": "pc-lebah-01",
      "bacaan": "pc-lebah",
      "topik": "informasi-tersurat",
      "tipe": "pg",
      "teks": "Berdasarkan teks, apa tugas ratu lebah?",
      "pilihan": [
        {
          "teks": "Mengisap nektar dari bunga",
          "alasan": "Mengisap nektar adalah tugas **lebah pekerja**, bukan ratu lebah."
        },
        {
          "teks": "Bertelur",
          "alasan": "Paragraf pertama: koloni dipimpin oleh seekor ratu lebah **yang bertugas bertelur**."
        },
        {
          "teks": "Menjaga pintu sarang",
          "alasan": "Menjaga pintu sarang disebut sebagai tugas **lebah pekerja** di paragraf kedua."
        },
        {
          "teks": "Menari untuk menunjukkan letak bunga",
          "alasan": "Tarian dilakukan oleh **lebah pekerja** yang baru pulang dari mencari nektar."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Setiap kelompok, atau koloni, dipimpin oleh seekor ratu lebah yang bertugas bertelur."
      ],
      "langkah": [
        {
          "teks": "Teks menyebut beberapa jenis lebah dengan tugas berbeda. Cari kata **ratu lebah**, lalu baca tugas yang disebut tepat di kalimat itu."
        }
      ]
    },
    {
      "id": "pc-lebah-02",
      "bacaan": "pc-lebah",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Apa yang dimaksud dengan nektar menurut teks?",
      "pilihan": [
        {
          "teks": "Serbuk sari yang menempel pada tubuh lebah",
          "alasan": "Serbuk sari berbeda dengan nektar. Serbuk sari dibahas di paragraf keempat dalam proses penyerbukan."
        },
        {
          "teks": "Lilin untuk membuat sarang",
          "alasan": "Lilin lebah adalah bahan ruang-ruang sarang, bukan nektar."
        },
        {
          "teks": "Madu yang disimpan di sarang",
          "alasan": "Madu adalah **hasil olahan** nektar. Nektar baru menjadi madu setelah dibawa ke sarang dan diolah."
        },
        {
          "teks": "Cairan manis di dalam bunga",
          "alasan": "Teks menjelaskan nektar langsung setelah kata **yaitu**: nektar adalah **cairan manis di dalam bunga**."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Mereka terbang dari bunga ke bunga untuk mengisap nektar, yaitu cairan manis di dalam bunga."
      ],
      "langkah": [
        {
          "teks": "Istilah dalam teks informasi sering langsung dijelaskan setelah kata **yaitu**. Cari kata “nektar” yang pertama kali muncul."
        },
        {
          "tanya": {
            "soal": "Nektar diolah lebah menjadi …",
            "pilihan": [
              "Lilin",
              "Madu",
              "Serbuk sari"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Karena nektar diolah **menjadi** madu, nektar dan madu adalah dua hal yang berbeda. Jangan tertukar."
        }
      ]
    },
    {
      "id": "pc-lebah-03",
      "bacaan": "pc-lebah",
      "topik": "informasi-tersurat",
      "tipe": "mcma",
      "teks": "Tugas lebah pekerja yang disebutkan dalam teks adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Mengisap nektar dari bunga",
          "benar": true,
          "alasan": "Disebut di paragraf kedua: lebah pekerja terbang dari bunga ke bunga untuk mengisap nektar."
        },
        {
          "teks": "Bertelur",
          "benar": false,
          "alasan": "Bertelur adalah tugas **ratu lebah**, bukan lebah pekerja."
        },
        {
          "teks": "Merawat lebah muda",
          "benar": true,
          "alasan": "Disebut di akhir paragraf kedua sebagai tugas lebah pekerja."
        },
        {
          "teks": "Menjaga pintu sarang dari pengganggu",
          "benar": true,
          "alasan": "Disebut di akhir paragraf kedua sebagai tugas lebah pekerja."
        },
        {
          "teks": "Memimpin koloni",
          "benar": false,
          "alasan": "Koloni dipimpin oleh **ratu lebah**, bukan lebah pekerja."
        }
      ],
      "bukti": [
        "Mereka terbang dari bunga ke bunga untuk mengisap nektar, yaitu cairan manis di dalam bunga.",
        "Lebah pekerja juga membersihkan sarang, merawat lebah muda, dan menjaga pintu sarang dari pengganggu."
      ],
      "langkah": [
        {
          "teks": "Tugas lebah pekerja dibahas di **paragraf kedua**. Tugas ratu lebah ada di paragraf pertama. Pastikan setiap tugas yang kamu pilih memang milik lebah pekerja."
        }
      ]
    },
    {
      "id": "pc-lebah-04",
      "bacaan": "pc-lebah",
      "topik": "kesesuaian-isi",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan teks.",
      "pernyataan": [
        {
          "teks": "Madu disimpan di ruang-ruang kecil berbentuk segi enam.",
          "benar": true,
          "alasan": "Benar. Paragraf kedua: madu disimpan di ruang-ruang kecil **berbentuk segi enam** dari lilin lebah."
        },
        {
          "teks": "Lebah jantan adalah anggota koloni yang paling banyak.",
          "benar": false,
          "alasan": "Salah. **Sebagian besar** anggota koloni adalah lebah pekerja, sedangkan lebah jantan jumlahnya **jauh lebih sedikit**."
        },
        {
          "teks": "Tarian lebah menunjukkan arah dan jarak bunga kepada lebah lain.",
          "benar": true,
          "alasan": "Benar. Paragraf ketiga: gerakan tarian menunjukkan **arah dan jarak** bunga kepada lebah lain."
        },
        {
          "teks": "Serbuk sari menempel pada tubuh lebah ketika lebah hinggap di bunga.",
          "benar": true,
          "alasan": "Benar. Paragraf keempat: ketika lebah hinggap di bunga, serbuk sari menempel pada tubuhnya yang berbulu."
        }
      ],
      "bukti": [
        "Madu disimpan di dalam ruang-ruang kecil berbentuk segi enam yang terbuat dari lilin lebah.",
        "Sebagian besar anggota koloni adalah lebah pekerja. Selain itu, ada lebah jantan yang jumlahnya jauh lebih sedikit.",
        "Gerakan tarian tersebut menunjukkan arah dan jarak bunga kepada lebah lain."
      ],
      "langkah": [
        {
          "teks": "Setiap pernyataan dibahas di paragraf yang berbeda. Cari kata kunci tiap pernyataan (**segi enam**, **lebah jantan**, **tarian**, **serbuk sari**) di teks, lalu bandingkan isinya."
        }
      ]
    },
    {
      "id": "pc-lebah-05",
      "bacaan": "pc-lebah",
      "topik": "sebab-akibat",
      "tipe": "pg",
      "teks": "Apa akibat serbuk sari yang menempel pada tubuh lebah terbawa ke bunga lain?",
      "pilihan": [
        {
          "teks": "Bunga menjadi layu",
          "alasan": "Teks tidak menyebut bunga menjadi layu. Akibatnya justru baik bagi bunga."
        },
        {
          "teks": "Lebah tidak bisa terbang",
          "alasan": "Teks tidak menyebut serbuk sari mengganggu lebah terbang."
        },
        {
          "teks": "Terjadi penyerbukan sehingga bunga dapat berkembang menjadi buah dan biji",
          "alasan": "Paragraf keempat: serbuk sari terbawa ke bunga lain **sehingga terjadi penyerbukan**, dan **berkat penyerbukan**, bunga dapat berkembang menjadi buah dan biji."
        },
        {
          "teks": "Madu menjadi pahit",
          "alasan": "Rasa madu tidak dibahas di teks."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Serbuk sari itu kemudian terbawa ke bunga lain sehingga terjadi penyerbukan. Berkat penyerbukan, bunga dapat berkembang menjadi buah dan biji."
      ],
      "langkah": [
        {
          "teks": "Kata **sehingga** dan **berkat** menunjukkan hubungan sebab-akibat. Baca bagian setelah kedua kata itu di paragraf keempat."
        },
        {
          "tanya": {
            "soal": "Peristiwa berpindahnya serbuk sari ke bunga lain disebut …",
            "pilihan": [
              "Penyerbukan",
              "Penguraian",
              "Penyimpanan"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Berkat **penyerbukan**, bunga dapat berkembang menjadi buah dan biji."
        }
      ]
    },
    {
      "id": "pc-lebah-06",
      "bacaan": "pc-lebah",
      "topik": "gagasan-pokok",
      "tipe": "pg",
      "teks": "Gagasan pokok paragraf keempat teks tersebut adalah …",
      "pilihan": [
        {
          "teks": "Jasa lebah bagi tumbuhan melalui penyerbukan",
          "alasan": "Kalimat utama paragraf keempat menyebut lebah **sangat berjasa bagi tumbuhan**. Kalimat lainnya menjelaskan caranya, yaitu lewat penyerbukan."
        },
        {
          "teks": "Bulu pada tubuh lebah",
          "alasan": "Bulu lebah hanya rincian kecil yang menjelaskan mengapa serbuk sari bisa menempel. Terlalu sempit untuk menjadi gagasan pokok."
        },
        {
          "teks": "Cara membuat racun serangga",
          "alasan": "Teks tidak menjelaskan cara membuat racun serangga. Racun serangga hanya disebut sebagai hal yang sebaiknya tidak disemprotkan sembarangan."
        },
        {
          "teks": "Bentuk sarang lebah",
          "alasan": "Bentuk ruang sarang dibahas di **paragraf kedua**, bukan paragraf keempat."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Lebah juga sangat berjasa bagi tumbuhan.",
        "Serbuk sari itu kemudian terbawa ke bunga lain sehingga terjadi penyerbukan."
      ],
      "langkah": [
        {
          "teks": "Gagasan pokok sering ada di **kalimat pertama** paragraf. Baca kalimat pertama paragraf keempat, lalu cek apakah kalimat-kalimat lainnya menjelaskan kalimat itu."
        }
      ]
    },
    {
      "id": "pc-pot-01",
      "bacaan": "pc-pot-bunga",
      "topik": "alur-peristiwa",
      "tipe": "pg",
      "teks": "Apa yang menyebabkan pot bunga di dekat pintu retak?",
      "pilihan": [
        {
          "teks": "Bayu sengaja menendang pot itu",
          "alasan": "Tidak ada yang menendang pot. Pot terkena bola yang dilempar."
        },
        {
          "teks": "Pot tersenggol teman-teman yang berlarian masuk kelas",
          "alasan": "Teman-teman berlarian masuk **setelah** pot retak, saat bel berbunyi. Mereka bahkan tidak melihat kejadiannya."
        },
        {
          "teks": "Bola yang dilempar Yohanes terlalu keras mengenai pot itu",
          "alasan": "Paragraf pertama: ketika Yohanes **melempar bola terlalu keras**, bola itu **mengenai pot bunga** hingga jatuh dan retak."
        },
        {
          "teks": "Pot sudah lama dan rapuh",
          "alasan": "Cerita tidak menyebut pot sudah tua atau rapuh. Pot retak karena terkena bola."
        }
      ],
      "kunci": "C",
      "bukti": [
        "Ketika Yohanes melempar bola terlalu keras, bola itu mengenai pot bunga di dekat pintu. Pot tanah liat itu jatuh dan retak."
      ],
      "langkah": [
        {
          "teks": "Soal ini menanyakan **penyebab**. Cari kalimat yang menceritakan pot retak, lalu lihat apa yang terjadi tepat sebelumnya."
        }
      ]
    },
    {
      "id": "pc-pot-02",
      "bacaan": "pc-pot-bunga",
      "topik": "perasaan-tokoh",
      "tipe": "pg",
      "teks": "Kalimat “Selama pelajaran, Yohanes tidak bisa berkonsentrasi” menunjukkan bahwa Yohanes merasa …",
      "pilihan": [
        {
          "teks": "Gelisah karena merasa bersalah",
          "alasan": "Yohanes terus memikirkan pot yang rusak dan **hatinya tidak tenang**. Ia tahu menutupi kesalahan dengan diam tetap tidak jujur. Inilah rasa bersalah."
        },
        {
          "teks": "Senang karena kesalahannya tidak ketahuan",
          "alasan": "Kalau senang, hatinya akan tenang. Cerita justru menyebut **hatinya tidak tenang**."
        },
        {
          "teks": "Mengantuk karena lelah bermain",
          "alasan": "Cerita tidak menyebut Yohanes mengantuk. Ia tidak bisa berkonsentrasi karena memikirkan pot bunga."
        },
        {
          "teks": "Marah kepada Bu Wulan",
          "alasan": "Tidak ada alasan Yohanes marah kepada Bu Wulan, dan cerita tidak menyebut hal itu."
        }
      ],
      "kunci": "A",
      "bukti": [
        "Selama pelajaran, Yohanes tidak bisa berkonsentrasi. Ia terus memikirkan pot bunga yang dirawat bersama oleh seluruh kelas itu. Hatinya tidak tenang."
      ],
      "langkah": [
        {
          "teks": "Baca kalimat-kalimat **sesudah** kalimat itu di paragraf ketiga. Di sana dijelaskan apa yang dipikirkan dan dirasakan Yohanes."
        },
        {
          "tanya": {
            "soal": "Apa yang terus dipikirkan Yohanes selama pelajaran?",
            "pilihan": [
              "Pot bunga yang retak",
              "Bola kecilnya",
              "Jam istirahat berikutnya"
            ],
            "jawaban": "A"
          },
          "setelah": "Betul. Ia terus memikirkan pot yang rusak karena ulahnya. Itulah tanda ia **merasa bersalah**."
        }
      ]
    },
    {
      "id": "pc-pot-03",
      "bacaan": "pc-pot-bunga",
      "topik": "alur-peristiwa",
      "tipe": "bs",
      "teks": "Tentukan benar atau salah setiap pernyataan berikut berdasarkan cerita.",
      "pernyataan": [
        {
          "teks": "Bayu awalnya menyarankan Yohanes untuk diam saja.",
          "benar": true,
          "alasan": "Benar. Bayu berbisik, “Yo, diam saja. Tidak ada yang tahu, kok.”"
        },
        {
          "teks": "Yohanes mengaku setelah Bayu lebih dulu berdiri.",
          "benar": false,
          "alasan": "Salah. Yohanes yang **lebih dulu** berdiri dan mengaku. Bayu baru ikut berdiri **tak lama kemudian**."
        },
        {
          "teks": "Bu Wulan meminta Yohanes dan Bayu bertanggung jawab.",
          "benar": true,
          "alasan": "Benar. Paragraf terakhir: Bu Wulan meminta keduanya bertanggung jawab."
        },
        {
          "teks": "Yohanes dan Bayu membeli bunga baru untuk menggantikan bunga yang rusak.",
          "benar": false,
          "alasan": "Salah. Yang rusak adalah **potnya**. Mereka membawa **pot baru dari rumah**, lalu memindahkan bunga yang lama ke pot itu."
        }
      ],
      "bukti": [
        "Bayu berbisik, “Yo, diam saja. Tidak ada yang tahu, kok.”",
        "Tak lama kemudian, Bayu ikut berdiri dan mengaku bahwa ia juga ikut bermain.",
        "Keesokan harinya, Yohanes dan Bayu membawa pot baru dari rumah dan memindahkan bunga itu dengan hati-hati."
      ],
      "langkah": [
        {
          "teks": "Perhatikan **urutan** peristiwa dan **benda** yang disebut. Pernyataan bisa salah karena urutannya terbalik atau bendanya tertukar."
        }
      ]
    },
    {
      "id": "pc-pot-04",
      "bacaan": "pc-pot-bunga",
      "topik": "watak",
      "tipe": "mcma",
      "teks": "Sifat baik Yohanes yang tampak dalam cerita tersebut adalah … Pilih semua jawaban yang benar.",
      "pilihan": [
        {
          "teks": "Jujur",
          "benar": true,
          "alasan": "Yohanes mengakui kesalahannya walaupun tidak ada yang melihat kejadian itu."
        },
        {
          "teks": "Berani",
          "benar": true,
          "alasan": "Saat kelas hening, Yohanes **berdiri** dan mengaku dengan suara bergetar. Ia takut, tetapi tetap berani mengaku."
        },
        {
          "teks": "Bertanggung jawab",
          "benar": true,
          "alasan": "Yohanes membawa pot baru dari rumah dan memindahkan bunga dengan hati-hati untuk mengganti pot yang retak."
        },
        {
          "teks": "Suka menyalahkan teman",
          "benar": false,
          "alasan": "Yohanes tidak menyalahkan Bayu. Ia mengaku bahwa dirinya yang melempar bola."
        },
        {
          "teks": "Tidak peduli pada barang milik kelas",
          "benar": false,
          "alasan": "Kebalikan dari cerita. Yohanes terus memikirkan pot yang dirawat bersama oleh seluruh kelas."
        }
      ],
      "bukti": [
        "Yohanes menarik napas, lalu berdiri. “Saya, Bu. Saya bermain bola di lorong dan bolanya mengenai pot itu. Maafkan saya,” katanya dengan suara bergetar.",
        "Keesokan harinya, Yohanes dan Bayu membawa pot baru dari rumah dan memindahkan bunga itu dengan hati-hati."
      ],
      "langkah": [
        {
          "teks": "Soal meminta **sifat baik**. Coret dulu pilihan yang berupa sifat buruk. Lalu cari bukti setiap sifat baik dalam ucapan dan tindakan Yohanes."
        }
      ]
    },
    {
      "id": "pc-pot-05",
      "bacaan": "pc-pot-bunga",
      "topik": "makna-kata",
      "tipe": "pg",
      "teks": "Kata “hening” pada kalimat “kelas menjadi hening” bermakna …",
      "pilihan": [
        {
          "teks": "Ramai",
          "alasan": "Kebalikan dari hening. Saat Bu Wulan bertanya, tidak ada yang berbicara."
        },
        {
          "teks": "Gelap",
          "alasan": "Hening berhubungan dengan suara, bukan cahaya."
        },
        {
          "teks": "Berantakan",
          "alasan": "Hening tidak berhubungan dengan kerapian kelas."
        },
        {
          "teks": "Sepi dan sunyi",
          "alasan": "Setelah Bu Wulan bertanya, semua murid diam sehingga kelas menjadi **sunyi**. Keheningan itu membuat Yohanes harus mengumpulkan keberanian untuk berdiri."
        }
      ],
      "kunci": "D",
      "bukti": [
        "Ketika Bu Wulan bertanya siapa yang membuat pot itu retak, kelas menjadi hening."
      ],
      "langkah": [
        {
          "teks": "Bayangkan suasana kelas saat guru bertanya siapa yang merusak pot, padahal tidak ada yang melihat kejadiannya. Apa yang biasanya dilakukan murid-murid?"
        }
      ]
    },
    {
      "id": "pc-pot-06",
      "bacaan": "pc-pot-bunga",
      "topik": "amanat",
      "tipe": "pg",
      "teks": "Amanat yang dapat dipetik dari cerita tersebut adalah …",
      "pilihan": [
        {
          "teks": "Kesalahan yang tidak dilihat orang lain boleh disembunyikan",
          "alasan": "Bertentangan dengan cerita. Yohanes justru merasa tidak tenang saat diam, dan Bu Wulan berterima kasih karena ia mengaku."
        },
        {
          "teks": "Berani mengakui kesalahan dan bertanggung jawab adalah sikap terpuji",
          "alasan": "Yohanes mengaku dan mengganti pot yang rusak. Bu Wulan pun **berterima kasih** atas keberanian mereka. Pesan ini berlaku untuk semua pembaca."
        },
        {
          "teks": "Bermain bola di dalam kelas lebih aman daripada di lorong",
          "alasan": "Cerita tidak menganjurkan bermain bola di dalam kelas. Pesannya tentang mengakui kesalahan."
        },
        {
          "teks": "Murid boleh melanggar aturan karena guru pasti memaafkan",
          "alasan": "Bukan pesan baik. Bu Wulan tetap meminta mereka bertanggung jawab, dan mereka tidak lagi bermain bola di lorong."
        }
      ],
      "kunci": "B",
      "bukti": [
        "Bu Wulan tidak marah. Ia berterima kasih karena mereka berani mengaku. Namun, Bu Wulan meminta keduanya bertanggung jawab."
      ],
      "langkah": [
        {
          "teks": "Amanat terlihat dari **cara masalah diselesaikan**. Masalahnya: pot retak dan tidak ada yang tahu. Penyelesaiannya: Yohanes mengaku dan mengganti pot. Pesan apa yang ingin disampaikan?"
        },
        {
          "tanya": {
            "soal": "Apa yang dilakukan Bu Wulan setelah Yohanes dan Bayu mengaku?",
            "pilihan": [
              "Marah besar",
              "Berterima kasih dan meminta mereka bertanggung jawab"
            ],
            "jawaban": "B"
          },
          "setelah": "Betul. Bu Wulan menghargai keberanian mengaku, tetapi tetap meminta tanggung jawab. Itulah pesan ceritanya."
        }
      ]
    }
  ]
}
